import { from } from 'form-data';

export { default as DefaultPage } from './DefaultPage';
export { default as BasicMessageList } from './BasicMessageList';
export { default as CompanyMessage } from './CompanyMessage';
export { default as Frui_pfbzPage} from './Frui_pfbzPage';
export { default as Frui_zzzzPage} from './Frui_zzzzPage';
export { default as Frui_pfxhPage} from './Frui_pfxhPage';
export { default as Frui_qpbzPage} from './Frui_qpbzPage';
export { default as Frui_qpfjPage} from './Frui_qpfjPage';
export { default as Frui_qpxhPage} from './Frui_qpxhPage';
export { default as FruiTempFilePage } from './FruiTempFilePage';
export { default as Frui_qppzPage} from './Frui_qppzPage';



// WEBPACK FOOTER //
// ./src/features/user/index.js